import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageFrLite() {
    return (
        <div className="privacy-policy-container">
 <h1>Politique de Confidentialité de Tasbih Dhikr Lite</h1>
      <p>Dernière mise à jour : 31 janvier 2024</p>

      <h2>Introduction</h2>
      <p>Bienvenue dans l'application Tasbih Dhikr Lite. Cette politique de confidentialité vise à vous informer sur la manière dont nous traitons vos données lorsque vous utilisez notre application. La seule collecte de données dans cette application est effectuée par AdMob, un service de publicité de Google, et nous ne recueillons pas activement de données personnelles.</p>

      <h2>1. Collecte et utilisation de vos données personnelles</h2>
      <h3>a. Types de données collectées</h3>
      <h4>i. Utilisation des données via AdMob</h4>
      <p>Notre application utilise AdMob pour afficher des publicités. AdMob peut collecter des données telles que votre adresse IP, l'identifiant de votre appareil et des informations sur votre utilisation de l'application. Ces informations sont utilisées pour fournir et améliorer l'expérience publicitaire.</p>

      <h3>b. Utilisation des données</h3>
      <p>Les données recueillies par AdMob sont utilisées pour :</p>
      <ul>
        <li>Fournir et personnaliser les publicités au sein de l'application.</li>
        <li>Analyser l'efficacité des publicités affichées.</li>
      </ul>

      <h3>c. Contrôle par l'utilisateur</h3>
      <p>Vous pouvez contrôler l'utilisation de vos données pour la publicité personnalisée via les paramètres de votre appareil.</p>

      <h2>2. Transfert de données</h2>
      <p>Vos informations peuvent être transférées et conservées sur des ordinateurs situés en dehors de votre état, province ou pays où les lois sur la protection des données peuvent différer.</p>

      <h2>3. Divulgation de vos données personnelles</h2>
      <p>Les données collectées par AdMob peuvent être partagées conformément à la politique de confidentialité de Google et aux exigences légales.</p>

      <h2>4. Sécurité de vos données personnelles</h2>
      <p>La sécurité de vos données est importante pour nous. Cependant, aucune méthode de transmission sur Internet ou de stockage électronique n'est sécurisée à 100 %.</p>

      <h2>5. Liens vers d'autres sites</h2>
      <p>Notre service peut contenir des liens vers d'autres sites. Si vous cliquez sur un lien tiers, vous serez dirigé vers le site de ce tiers.</p>

      <h2>6. Modifications de cette politique de confidentialité</h2>
      <p>Nous pouvons mettre à jour notre politique de confidentialité de temps à autre. Nous vous informerons de tout changement en publiant la nouvelle politique de confidentialité sur cette page.</p>

      <h2>7. Contactez-nous</h2>
      <p>Si vous avez des questions sur cette politique de confidentialité, veuillez nous contacter.</p>

      <h2>Liens utiles</h2>
      <p><a href="https://policies.google.com/privacy">Politique de confidentialité de Google</a></p>
    </div>
    );
}

export default PrivacyPolicyPageFrLite;
